<template>
  <div v-if="message" class="data-status" :class="{ 'pcd-status-inline': placement === 'inline' }" role="status" aria-live="polite">
    {{ t(message) }}
    <button v-if="wallet.isConnected && !wallet.connectionError && account.chainId === 137" @click="wallet.fetchAllData(true)">{{ t("重新讀取") }}</button>
    <button v-else :disabled="walletRecoveryState === 'restoring'" @click="wallet.connectWallet()">{{ t(wallet.isConnected ? '切換至 Polygon' : '連接錢包') }}</button>
  </div>
</template>
<script setup>
import { t } from '@/i18n';
import { walletRecoveryState } from '@/composables/walletRecovery';
import { computed } from 'vue';
import { useWalletAccount } from '@/composables/useWalletAccount';
import { useWalletStore } from '@/stores/walletStore';
defineProps({ placement: { type: String, default: 'fixed' } });
const wallet = useWalletStore();
const account = useWalletAccount();
const message = computed(() => {
  if (walletRecoveryState.value === 'restoring' && !wallet.isConnected) return '正在恢復錢包連接…';
  if (wallet.connectionError) return wallet.connectionError;
  if (!wallet.isConnected) return '請使用 RiceApp 或錢包內建瀏覽器連接錢包，查看您的資產。';
  if (account.value.chainId !== 137) return '請將錢包切換至 Polygon 網路。';
  const labels = { contracts: '合約資料', polBalance: 'POL 餘額', pctPrice: 'PCT 價格' };
  const failed = Object.keys(wallet.dataStatus).filter(key => wallet.dataStatus[key] === 'error');
  if (failed.length) return `${failed.map(key => labels[key]).join('、')}讀取失敗；已成功的資料仍可查看，舊資料可能尚未更新。`;
  if (Object.values(wallet.dataStatus).some(value => value === 'loading')) return '正在讀取 Polygon 資料…';
  return '';
});
</script>
<style scoped>
.data-status { position: fixed; bottom: 56px; left: 0; right: 0; z-index: 2000; padding: 8px 12px; background: #0f1a0f; color: #cce7d8; font-size: 13px; }
button { margin-left: 8px; color: inherit; border: 1px solid currentColor; background: transparent; border-radius: 4px; }
.data-status.pcd-status-inline { position: static; padding: 12px 16px; margin: 0 0 20px; border-radius: 12px; font-size: 14px; line-height: 1.6; background: var(--pcd-surface); color: var(--pcd-text-muted); }
.pcd-status-inline button { min-height: 44px; margin: 8px 0 0; padding: 8px 12px; display: block; border-color: var(--pcd-control-border); border-radius: 8px; }
</style>
